import { ListRequestParams } from 'modules/domain/types'
import { MovementType, WarehouseMovement } from 'modules/domain/warehouses/types'
import { endpoints } from 'modules/endpoints'
import { Dispatch, FC, SetStateAction } from 'react'
import { useParams } from 'react-router-dom'
import ATableFullPage from 'views/components/Table/ATableFullPage'
import { defaultTheme } from '@agro-club/agroclub-shared'
import { NestedShipmentsTable } from './NestedShipmentsTable/NestedShipmentsTable'
import useColumns from './useColumns'

type Props = {
  listRequestParams: ListRequestParams
  setListRequestParams: Dispatch<SetStateAction<ListRequestParams>>
  isFiltersLoaded: boolean
}

export const MovementsUngrouped: FC<Props> = ({ isFiltersLoaded, setListRequestParams, listRequestParams }) => {
  const { id } = useParams()
  const columns = useColumns()

  const expandable = {
    showExpandColumn: true,
    rowExpandable: (row: WarehouseMovement) => !!row.shipments.length,
    expandedRowRender: (row: WarehouseMovement) => <NestedShipmentsTable shipments={row.shipments} />,
  }

  return (
    <ATableFullPage
      listRequestParams={listRequestParams}
      listParamsUpdated={setListRequestParams}
      dataEndpoint={endpoints.warehouseMovementsById(id)}
      isFiltersLoaded={isFiltersLoaded}
      columns={columns}
      nonClickableRow
      expandable={expandable}
      onRow={(record: WarehouseMovement) => ({
        style: {
          backgroundColor:
            record.movement_type === MovementType.outcome
              ? defaultTheme.color.accentDestruct16a
              : defaultTheme.color.accentApprove16a,
        },
      })}
    />
  )
}
